"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DomainObject_1 = require("../../core/model/DomainObject");

var moment = require("moment");

var GenericTreeReportHeader =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(GenericTreeReportHeader, _DomainObject_1$Domai);

  /**
   *
   * @param id
   * @param tree
   * @param treeMapping
   * @param completed State of report. True if report is already created.
   * @param error
   * @param params
   */
  function GenericTreeReportHeader(id, tree, treeMapping, completed, error, params) {
    var _this;

    _classCallCheck(this, GenericTreeReportHeader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GenericTreeReportHeader).call(this));
    _this.id = id;
    _this.tree = tree;
    _this.treeMapping = treeMapping;
    _this.completed = completed;
    _this.error = error;
    _this.params = params;
    _this.created = moment();
    return _this;
  }
  /**
   * Returns node by given path of IDs.
   * @param path
   */


  _createClass(GenericTreeReportHeader, [{
    key: "getNodeByPath",
    value: function getNodeByPath(path) {
      return this.getNodeByPathInternal(this.tree, path);
    }
  }, {
    key: "getNodeByPathInternal",
    value: function getNodeByPathInternal(node, path) {
      var sub = path.shift();

      if (sub) {
        var child = node.children.find(function (ch) {
          return ch.id === sub;
        });

        if (child) {
          return this.getNodeByPathInternal(child, path);
        }

        return node;
      }

      return node;
    }
  }]);

  return GenericTreeReportHeader;
}(DomainObject_1.DomainObject);

exports.GenericTreeReportHeader = GenericTreeReportHeader;
GenericTreeReportHeader.DUMMY = new GenericTreeReportHeader('', {
  id: '',
  parentId: null,
  children: [],
  level: 1
}, immutable_1.Map(), false, null, {});